var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout-catalog-category-card",style:({
    gridColumn: `span ${_vm.horizontal}`,
    gridRow: `span ${_vm.vertical}`
  }),on:{"click":function($event){return _vm.locations()}}},[(_vm.image)?_c('img',{staticClass:"abs",staticStyle:{"object-fit":"cover"},attrs:{"loading":"lazy","data-src":_vm.image,"alt":"locations"}}):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }